import React, { useEffect } from 'react';
import Slider from 'react-slick';
import styled from 'styled-components';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import health from "./../../assets/images/health.svg"
import chat from "./../../assets/images/chat.svg"
import banner1 from "./../../assets/images/bannerImg1.png";
import banner2 from "./../../assets/images/bannerImg2.png";

const CarouselContainer = styled.div`
  width: 50%;
  margin: 0 auto;
`;

const Slide = styled.div`
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  background: linear-gradient(180deg, #3b82f6, #9333ea); 
  color: white;
  font-size: 24px;
  font-weight: bold;
`;

const CustomDot = styled.div`
  width: ${(props) => (props.active ? '30px' : '10px')};
  height: 10px;
  border-radius: ${(props) => (props.active ? '5px' : '50%')};
  background: ${(props) => (props.active ? '#ffffff' : '#F7F7F7')};
  margin: 0 5px;
  transition: all 0.3s ease-in-out;
  cursor: pointer; /* Make the indicators clickable */
`;

const Banner = () => {
    const sliderRef = React.useRef(null); // Reference to the slider
    const [currentSlide, setCurrentSlide] = React.useState(0);
    const settings = {
        dots: true,
        infinite: true,
        speed: 1000,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 3000,
        beforeChange: (_, next) => setCurrentSlide(next),
        appendDots: (dots) => (
            <div
                style={{
                    display: 'none', // Hide the default outer dots
                }}
            >
                {dots}
            </div>
        ),
    };

    const slides = [{ img: banner1, icon: health, headingText: "Advancing Health Through Innovation.", dec: "Driving breakthroughs in healthcare to improve lives through innovative research." }, 
        { img: banner2, icon: chat, headingText: "Seamless Conversations, Anytime", dec: "Effortless communication and support, just a message away" }];
    
    return (
        <CarouselContainer>
            <Slider {...settings} ref={sliderRef}>
                {slides.map((slide, index) => (
                    <Slide key={index}>
                        <div
                            style={{
                                backgroundImage: `url(${slide.img})`,
                                width: '100%',
                                height: '100%',
                                backgroundSize: 'cover',
                                backgroundPosition: 'center',
                                display: 'flex',
                                justifyContent: 'center',
                            }}
                        >
                            <div
                                className="max-w-sm  bg-transparent rounded-lg shadow-md flex items-center p-5 py-2 min-w-[525px] min-h-[584px] my-[auto] relative"
                                style={{
                                    border: "0.88px solid",
                                    borderImageSource:
                                        "radial-gradient(102.1% 102.1% at 17.33% 0%, #FFFFFF 0%, rgba(228, 228, 228, 0.750969) 63.85%, rgba(255, 255, 255, 0.61) 100%)",
                                    borderImageSlice: 1,
                                    background: 'rgba(183, 233, 246, 0.25)',
                                }}
                            >
                                <div className="mr-4">
                                    {/* <img src={icon} alt="Icon" className="w-12 h-12" /> */}
                                </div>
                                <div className='mb-[100px]'>
                                    <div>
                                        <img src={slide.icon} style={{marginBottom:'50px'}}/>
                                    </div>
                                    <h2 className="font-mont font-[600] text-[30px] mb-5">{slide.headingText}</h2>
                                    <p className="font-mont font-[500] text-[16px]">
                                       {slide.dec}
                                    </p>
                                </div>
                                {/* Custom Dots */}
                                <div
                                    style={{
                                        position: 'absolute',
                                        bottom: '0px',
                                        left: "-30%",
                                        display: 'flex',
                                        justifyContent: 'center',
                                        width: '100%',
                                    }}
                                >
                                    <div
                                        style={{
                                            display: 'flex',
                                            justifyContent: 'center',
                                            padding: '10px',
                                            marginTop: '-50px',
                                        }}
                                    >
                                        {slides.map((_, dotIndex) => (
                                            <CustomDot
                                                key={dotIndex}
                                                active={dotIndex === currentSlide}
                                                onClick={() => sliderRef.current.slickGoTo(dotIndex)} // Navigate to slide
                                            />
                                        ))}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </Slide>
                ))}
            </Slider>
        </CarouselContainer>
    );
};

export default Banner
